module.exports = __webpack_public_path__ + "static/media/sf_hotel_8.4ad91bc0.jpg";